import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './torneio_diegoftv00.module.scss';
import { FaArrowLeft, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const WHATSAPP_NUMBER = '5517988393564';

const TORNEIO_TITULO = 'Torneio FTV - LB & DS';
const TORNEIO_TAGLINE = 'Uma parceria que vai ser sucesso!';
const LOCAL = 'Complexo Top Soccer, Bebedouro/SP';
const DATAS = '24 e 25 de outubro';
const INSCRICAO = 'Inscrição R$ 160,00';

const MAP_EMBED_SRC =
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3726.4415405507566!2d-48.4660301!3d-20.9347763!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94bbe7d2869af629%3A0x8e7afd0be16bcd77!2sTop%20Soccer%20Bebedouro!5e0!3m2!1spt-BR!2sbr!4v1774641221216!5m2!1spt-BR!2sbr';

type CategoriaTorneio = {
    id: string;
    nome: string;
    data: string;
    premios: string[];
};

const CATEGORIAS: CategoriaTorneio[] = [
    {
        id: 'principiante',
        nome: 'Principiante Masculino',
        data: '24/10',
        premios: [
            'Campeão: R$ 300,00',
            'Vice-campeão: R$ 200,00',
            'Terceiro lugar: Troféu',
        ],
    },
    {
        id: 'intermediario',
        nome: 'Intermediário',
        data: '24/10',
        premios: [
            'Campeão: R$ 700,00',
            'Vice-campeão: R$ 400,00',
            'Terceiro lugar: R$ 200,00',
        ],
    },
    {
        id: 'misto',
        nome: 'Misto iniciante',
        data: '25/10',
        premios: [
            'Campeão: R$ 300,00',
            'Vice-campeão: R$ 200,00',
            'Terceiro lugar: Troféu',
        ],
    },
    {
        id: 'iniciante',
        nome: 'Iniciante Masculino',
        data: '25/10',
        premios: [
            'Campeão: R$ 400,00',
            'Vice-campeão: R$ 300,00',
            'Terceiro lugar: R$ 200,00',
        ],
    },
];

const CARTAZES = [
    {
        src: require('./src/torneio.png'),
        alt: `Cartaz do ${TORNEIO_TITULO}`,
    },
    {
        src: require('./src/torneio2.png'),
        alt: `Premiações do ${TORNEIO_TITULO}`,
    },
];

function buildWhatsAppUrl(categoria: CategoriaTorneio) {
    const msg =
        `Olá! Gostaria de me inscrever no ${TORNEIO_TITULO}. ` +
        `Categoria: ${categoria.nome} (${categoria.data}). ${INSCRICAO}. ` +
        `Datas: ${DATAS}. Local: ${LOCAL}.`;
    return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
}

const Torneio_diegoftv00: React.FC = () => {
    const [cartazIndex, setCartazIndex] = useState(0);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const cartazAnterior = () => {
        setCartazIndex((atual) => (atual === 0 ? CARTAZES.length - 1 : atual - 1));
    };

    const cartazProximo = () => {
        setCartazIndex((atual) => (atual === CARTAZES.length - 1 ? 0 : atual + 1));
    };

    return (
        <div className={styles.torneio_diegoftv00}>
            <div className={styles.pageWrapper}>
                <div className={styles.inner}>
                    <div className={styles.header}>
                        <div className={styles.headerNav}>
                            <Link to="/diegoftv00" className={styles.backButton} aria-label="Voltar">
                                <FaArrowLeft />
                            </Link>
                        </div>
                        <h1 className={styles.title}>{TORNEIO_TITULO}</h1>
                        <p className={styles.subtitle}>{TORNEIO_TAGLINE}</p>
                    </div>

                    <div className={styles.carousel} aria-roledescription="carrossel">
                        <div className={styles.carouselFrame}>
                            <img
                                className={styles.heroImg}
                                src={CARTAZES[cartazIndex].src}
                                alt={CARTAZES[cartazIndex].alt}
                            />
                            <button
                                type="button"
                                className={`${styles.carouselArrow} ${styles.carouselPrev}`}
                                onClick={cartazAnterior}
                                aria-label="Cartaz anterior"
                            >
                                <FaChevronLeft />
                            </button>
                            <button
                                type="button"
                                className={`${styles.carouselArrow} ${styles.carouselNext}`}
                                onClick={cartazProximo}
                                aria-label="Próximo cartaz"
                            >
                                <FaChevronRight />
                            </button>
                        </div>
                        <div className={styles.carouselDots}>
                            {CARTAZES.map((cartaz, index) => (
                                <button
                                    type="button"
                                    key={cartaz.alt}
                                    className={`${styles.carouselDot} ${
                                        index === cartazIndex ? styles.carouselDotActive : ''
                                    }`}
                                    onClick={() => setCartazIndex(index)}
                                    aria-label={`Ver cartaz ${index + 1}`}
                                />
                            ))}
                        </div>
                    </div>

                    {/* <div className={styles.section}>
                        <div className={styles.sectionHeader}>
                            <h2 className={styles.sectionTitle}>Categorias</h2>
                        </div>
                        <p className={styles.sectionDate}>Sábado — 24/10</p>
                        <ul className={styles.premiosList}>
                            <li>Principiante Masculino</li>
                            <li>Intermediário</li>
                        </ul>
                        <p className={styles.sectionDate}>Domingo — 25/10</p>
                        <ul className={styles.premiosList}>
                            <li>Misto iniciante</li>
                            <li>Iniciante Masculino</li>
                        </ul>
                    </div>

                    <div className={styles.section}>
                        <div className={styles.sectionHeader}>
                            <h2 className={styles.sectionTitle}>Quando e onde</h2>
                        </div>
                        <ul className={styles.premiosList}>
                            <li>{DATAS}</li>
                            <li>{LOCAL}</li>
                            <li>{INSCRICAO}</li>
                            <li>Premiações em dinheiro</li>
                            <li>Troféus</li>
                        </ul>
                    </div> */}

                    {CATEGORIAS.map((cat) => (
                        <div key={cat.id} className={styles.section}>
                            <div className={styles.sectionHeader}>
                                <h2 className={styles.sectionTitle}>{cat.nome}</h2>
                                <p className={styles.sectionInscricao}>{INSCRICAO}</p>
                            </div>
                            <p className={styles.sectionDate}>{cat.data}</p>
                            <ul className={styles.premiosList}>
                                {cat.premios.map((linha) => (
                                    <li key={linha}>{linha}</li>
                                ))}
                            </ul>
                            <a
                                href={buildWhatsAppUrl(cat)}
                                className={styles.cta}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Inscrever - {cat.nome}
                            </a>
                        </div>
                    ))}

                    <div className={styles.locationSection} aria-labelledby="local-torneio-heading">
                        <h2 id="local-torneio-heading" className={styles.locationHeading}>
                            Local do evento
                        </h2>
                        <p className={styles.locationName}>Complexo Top Soccer</p>
                        <p className={styles.locationCity}>Bebedouro/SP</p>
                        <div className={styles.mapEmbed}>
                            <iframe
                                src={MAP_EMBED_SRC}
                                title="Mapa: Top Soccer Bebedouro"
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                allowFullScreen
                            />
                        </div>
                    </div>

                    <div className={styles.footer}>
                        <img
                            src={require('./src/logo.png')}
                            alt="DS"
                            className={styles.footerLogo}
                        />
                        <img
                            src={require('./src/logo_topsoccer.png')}
                            alt="Top Soccer"
                            className={styles.footerLogo}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Torneio_diegoftv00;
